import Map from './Map.jsx'

export default Map
